import React from "react"

const DetailField = (props) => {
  const { label, children, style } = props

  const labelStyle = {
    color: "#4a4a4a",
    fontWeight: 900,
    fontSize: "1.6rem",
    marginRight: "12px",
  }

  return (
    <div style={style || { display: "flex", marginBottom: 5 }}>
      <span style={labelStyle}>{label}</span>
      {children}
    </div>
  )
}

export default DetailField
